import React, { useState } from 'react';
import './Popup.css';
import { FILE_BASE_URL } from '../../../Config/constants';

function Popup({ images, onSelect, onClose }) {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedImages, setSelectedImages] = useState([]);

    const filteredImages = images.filter(image =>
        image.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const toggleSelect = (image) => {
        if (selectedImages.some(img => img.contentId === image.contentId)) {
            setSelectedImages(prev => prev.filter(img => img.contentId !== image.contentId));
        } else {
            setSelectedImages(prev => [...prev, image]);
        }
    };

    const handleAddSelected = () => {
        onSelect(selectedImages); // Pass array to parent
        setSelectedImages([]);
        onClose();
    };

    return (
        <div className="popup-overlay d-flex justify-content-center align-items-center">
            <div className="popup-content bg-white p-4 rounded shadow-lg w-75">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">📁 Media Library</h4>
                    <button className="btn btn-sm btn-danger" onClick={onClose}>×</button>
                </div>

                <input
                    type="text"
                    className="form-control mb-3"
                    placeholder="🔍 Search media..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />

                <div className="table-responsive">
                    <table className="table table-bordered table-hover table-striped">
                        <thead className="thead-dark">
                            <tr>
                                <th>Select</th>
                                <th>Preview</th>
                                <th>Title</th>
                                <th>Type</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredImages.length === 0 ? (
                                <tr>
                                    <td colSpan="4" className="text-center">No media found.</td>
                                </tr>
                            ) : (
                                filteredImages.map(image => (
                                    <tr key={image.contentId}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={selectedImages.some(img => img.contentId === image.contentId)}
                                                onChange={() => toggleSelect(image)}
                                            />
                                        </td>
                                        <td style={{ width: '150px' }}>
                                            {image.type === 'Video' ? (
                                                <video
                                                    src={`${FILE_BASE_URL}/${encodeURIComponent(image.url)}`}
                                                    width="100"
                                                    controls
                                                    muted
                                                />
                                            ) : image.type === 'Image' ? (
                                                <img
                                                    src={`${FILE_BASE_URL}/${encodeURIComponent(image.url)}`}
                                                    alt={image.title}
                                                    width="100"
                                                    className="img-thumbnail"
                                                />
                                            ) : image.type === 'PDF' ? (
                                                <a
                                                    href={`${FILE_BASE_URL}/${encodeURIComponent(image.url)}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-outline-secondary btn-sm"
                                                >
                                                    📄 View PDF
                                                </a>
                                            ) : (
                                                <span className="text-muted">N/A</span>
                                            )}
                                        </td>
                                        <td>{image.title}</td>
                                        <td>{image.type}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="d-flex justify-content-end mt-3">
                    <button className="btn btn-secondary mr-2" onClick={onClose}>Cancel</button>
                    <button className="btn btn-primary" onClick={handleAddSelected} disabled={selectedImages.length === 0}>
                        Add Selected ({selectedImages.length})
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Popup;
